<script setup lang="ts">
import CategoryCardList from '@/pages/catalog/ui/CategoryCardList.vue';
import type { Category } from '@/entities/categories/model/types/categories';
import { COMPANY_TELEGRAM_LINK } from '@/shared/constants/contacts';

const { t } = useI18n();
const localePath = useLocalePath();

const categories: Ref<Category[]> = ref([
  {
    id: 1,
    name: t('forBusinessPage.products.drinks'),
    icon: '/images/for-business/napitki.webp',
  },
  {
    id: 2,
    name: t('forBusinessPage.products.cosmetics'),
    icon: '/images/for-business/kosmetika.webp',
  },
  {
    id: 3,
    name: t('forBusinessPage.products.chocolate'),
    icon: '/images/for-business/chocolad.webp',
  },
  {
    id: 4,
    name: t('forBusinessPage.products.dietary-supplements'),
    icon: '/images/for-business/biodobavki.webp',
  },
  {
    id: 5,
    name: t('forBusinessPage.products.food'),
    icon: '/images/for-business/producti-pitaniya.webp',
  },
]);
</script>

<template>
  <div class="products-section">
    <h2 class="products-section__title">
      {{ t('forBusinessPage.productsSectionTitle') }}
    </h2>
    <div class="products-section__products">
      <CategoryCardList :categories="categories" />
    </div>
    <div class="products-section__links">
      <a
        :href="COMPANY_TELEGRAM_LINK"
        class="products-section__link"
        :aria-label="t('forBusinessPage.getPriceList')"
      >
        {{ t('forBusinessPage.getPriceList') }}
      </a>
      <nuxt-link
        class="products-section__link _catalog"
        :to="localePath('catalog')"
        :aria-label="t('forBusinessPage.viewInStore')"
      >
        {{ t('forBusinessPage.viewInStore') }}
      </nuxt-link>
    </div>
  </div>
</template>

<style lang="less">
.products-section {
  .flex-column(@size-x6);

  &__title {
    .h-offset-reset();

    font-size: 48px;
    font-weight: 500;
    line-height: 110%;
  }

  &__links {
    display: flex;
    justify-content: center;
    gap: @size-x6;
    margin-top: @size-x6;
  }

  &__link {
    display: inline-flex;
    justify-content: center;
    gap: @size-x2;
    align-items: center;
    vertical-align: top;
    background-color: @color-tango;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
    width: 100%;
    border-radius: @size-x3;
    transition: all @A linear;
    height: 89px;
    padding: @size-x3 @size-x4;
    white-space: nowrap;
    max-width: 201px;

    &:hover:not(._catalog) {
      opacity: 0.75;
    }

    &._catalog {
      max-width: 248px;
      background-color: #fff;
      color: @color-cod-gray;
      border: 1px solid @color-tango;

      &:hover {
        color: #fff;
        background-color: @color-tango;
      }
    }
  }

  @media @1024 {
    gap: @size-x4;

    &__links {
      flex-direction: column;
      gap: @size-x4;
      margin-top: @size-x2;
    }

    &__link {
      height: 43px;
      max-width: 100%;

      &._catalog {
        max-width: 100%;
      }
    }

    &__title {
      font-size: @size-x6;
      max-width: 270px;
    }
  }
}
</style>
